module.exports = __webpack_public_path__ + "img/prev-arrow.85068758.svg";